import { BoxProps as BoxPropAlias } from './Box';

export { Box } from './Box';

export type BoxProps = BoxPropAlias;
